// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2jbpK","productName":"Table_productName__1MhPB"};